import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

  type SafeTextFieldProps = TextFieldProps & {
  allowedPattern?: RegExp; // custom allowed pattern
};
const SafeTextField: React.FC<SafeTextFieldProps> = (props) => {
  const { onChange, inputProps,allowedPattern, ...rest } = props;



const handleSafeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  if (inputProps?.mask) {
    onChange?.(event);
    return;
  }
  if (allowedPattern) {
      event.target.value = event.target.value.replace(
        new RegExp(`[^${allowedPattern.source}]`, "g"),
        ""
      );
    } else {
      // default: only letters, numbers, spaces
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s,.-/:&@]/g, "");
    }

    onChange?.(event);
};

  return (
    <TextField
      {...rest}
      inputProps={{
        ...(inputProps || {}),
        // If DatePicker injected "__/__/____", fix it to "__-__-____"
        mask:
          inputProps?.mask === "__/__/____"
            ? "__-__-____"
            : inputProps?.mask,
      }}
      onChange={handleSafeChange}
    />
  );
};

export default SafeTextField;
